import React from 'react';
import styled from 'styled-components';
import { theme } from '../../config/theme';
import IndicatorCard from './IndicatorCard';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  align-items: stretch;
  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const SOLID_GREEN = theme.colors.success.replace('0.15', '1');
// Escala con el viewport para que un monto de 12 dígitos + decimales entre en una línea.
const VALUE_SIZE = 'clamp(1.2rem, 0.9vw + 0.65rem, 1.6rem)';

const signColor = (value) => {
  if (value > 0) return SOLID_GREEN;
  if (value < 0) return theme.colors.errorText;
  return theme.colors.primary;
};

const DashboardIndicators = ({ moneda, data, onShowEjecutados, onShowPendientes }) => {
  const { saldoInicio, saldoInicioEsFallback, saldoActual, saldoProyectado, variacion, pendientes } = data;
  return (
    <Grid>
      <IndicatorCard
        title="Saldo al inicio del día"
        value={saldoInicio}
        currency={moneda}
        color={theme.colors.primary}
        valueSize={VALUE_SIZE}
        secondaryLabel={saldoInicioEsFallback
          ? 'según última carga — sin snapshot inicial hoy'
          : 'según snapshot inicial del custodio'}
      />
      <IndicatorCard
        title="Saldo actual (real)"
        value={saldoActual}
        currency={moneda}
        color={signColor(saldoActual)}
        valueSize={VALUE_SIZE}
        secondaryLabel="Proyectado (incluye pendientes):"
        secondaryValue={saldoProyectado}
        onClick={onShowEjecutados}
      />
      <IndicatorCard
        title="Variación del día (real)"
        value={variacion}
        currency={moneda}
        color={signColor(variacion)}
        valueSize={VALUE_SIZE}
        valuePrefix={variacion > 0 ? '+' : ''}
        secondaryLabel="saldo actual vs. inicio del día"
        onClick={onShowEjecutados}
      />
      <IndicatorCard
        title="Pendientes de ejecución"
        value={pendientes.monto}
        currency={moneda}
        color={pendientes.cantidad > 0 ? '#B45309' : theme.colors.primary}
        valueSize={VALUE_SIZE}
        secondaryLabel={pendientes.cantidad > 0
          ? `${pendientes.cantidad} ${pendientes.cantidad === 1 ? 'movimiento' : 'movimientos'} — impacto sobre saldo proyectado`
          : 'Sin movimientos pendientes'}
        onClick={onShowPendientes}
      />
    </Grid>
  );
};

export default DashboardIndicators;
